import { FinancialText } from '#components/FinancialText';
import { PrivacyFilter } from '#components/PrivacyFilter';
import { useFormat } from '#hooks/useFormat';

type PortfolioAmountProps = {
  value: number | null;
  testId?: string;
};

export function PortfolioAmount({ value, testId }: PortfolioAmountProps) {
  const format = useFormat();
  return (
    <FinancialText data-testid={testId} style={{ whiteSpace: 'nowrap' }}>
      <PrivacyFilter>
        {value === null ? '…' : format(value, 'financial')}
      </PrivacyFilter>
    </FinancialText>
  );
}
